import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../../conexoes/api'; 
import '../../../css/componentesModais/selects/Select.css';


export default function SelectSolicitacaoTipo(props) {
    const [lsSolicitacaoTipos, setLsSolicitacaoTipos] = useState([])
    //HOOKS MODAL
    const [spinAtivo, setSpinAtivo] = useState(true);
    const modal = useRef();

   

    function handleSolicitacaoTipo(SolicitacaoTipo,cdSolicitacaoTipo){
        props.setDsSolicitacaoTipo(SolicitacaoTipo)
        props.setCdSolicitacaoTipo(cdSolicitacaoTipo)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectSolicitacaoTipo(false)
    }

    useEffect(() => {
        async function renderSolicitacaoTipos(){
            const {data} = await api_gateway.get('/m1/consultar/tipo_solicitacao');
            
            if(data.dados.length > 0){
                let objetoSolicitacaoTipos = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.cd_crm_solicitacao_tipo}>
                            <div className="select-pav-menu-tipo-solicitacao campo-select-opcao-2" onClick={() => handleSolicitacaoTipo(item.ds_crm_solicitacao_tipo, item.cd_crm_solicitacao_tipo) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label-tipo-solicitacao nao-selecionavel">{item.ds_crm_solicitacao_tipo}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsSolicitacaoTipos(objetoSolicitacaoTipos)
            }else{
                let objetoSolicitacaoTipos = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsSolicitacaoTipos(objetoSolicitacaoTipos)
            }
            setSpinAtivo(false)
        }
        renderSolicitacaoTipos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsSolicitacaoTipos}
                </ul>
            </div>
        </Form>
    )
}